import { render, staticRenderFns } from "./comentariosList.vue?vue&type=template&id=4cb60991&"
import script from "./comentariosList.vue?vue&type=script&lang=js&"
export * from "./comentariosList.vue?vue&type=script&lang=js&"
import style0 from "./comentariosList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports